import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '@angular/common';

// import swal from 'sweetalert2';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoProjeto } from '../../servicos/srv.projeto';

@Component({
  selector: 'tsv2-prj-visualizar',
  templateUrl: './visualizar.component.html',
  providers: [ ServicoMsg, ServicoProjeto ]
})
export class ProjetoVisualizarComponent implements OnInit {
  exibirBarra: boolean = true;
  p: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    // private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoProjeto: ServicoProjeto,
    private _location: Location
  ) { }

  ngOnInit() {
    // this.spinner.show();
    const id = this.route.snapshot.params['id'];
    this.servicoProjeto.consultarProjeto(id).subscribe(res => {
      this.p = res.lista[0];
      // this.spinner.hide();
    }, (err) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

  voltar(){
    this._location.back();
  }

  removerProjeto(id){
    let titulo = 'Remover o projeto?';
    let url = '/projeto/pesquisar/';
    let texto = 'Projeto removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoProjeto, texto).then(r1 => {
      if (r1.success){
        this.router.navigate([url]);
      }
    }, (err: any) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
